import { Link } from "@remix-run/react";
import { Layout } from "./layout";

export const NotFoundErrorBoundary = () => {
  return (
    <Layout>
      <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-red-100 text-red-500 mb-6">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        
        <h1 className="text-3xl font-bold mb-2">Page Not Found</h1>
        <p className="text-lg text-slate-600 dark:text-slate-300 mb-8 max-w-md">
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        
        <div className="space-x-4">
          <Link 
            to="/"
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-colors"
          >
            Go to Homepage
          </Link>
          <Link
            to="/kb"
            className="inline-block bg-slate-200 hover:bg-slate-300 text-slate-800 px-6 py-3 rounded-lg transition-colors"
          >
            Browse Knowledge Base
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export const GeneralErrorBoundary = () => {
  return (
    <Layout>
      <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-red-100 text-red-500 mb-6">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        
        <h1 className="text-3xl font-bold mb-2">Something Went Wrong</h1>
        <p className="text-lg text-slate-600 dark:text-slate-300 mb-8 max-w-md">
        We&apos;ve encountered an unexpected error. Our team has been notified and we&apos;re working to fix the issue.
        </p>
        
        <div className="space-x-4">
          <Link 
            to="/"
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-colors"
          >
            Go to Homepage
          </Link>
          <Link
            to="/kb"
            className="inline-block bg-slate-200 hover:bg-slate-300 text-slate-800 px-6 py-3 rounded-lg transition-colors"
          >
            Browse Knowledge Base
          </Link>
        </div>
      </div>
    </Layout>
  );
};
